var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8027 3.71094H2.19727C0.988184 3.71094 0 4.69478 0 5.9082V19.0918C0 20.3057 0.988818 21.2891 2.19727 21.2891H22.8027C24.0118 21.2891 25 20.3052 25 19.0918V5.9082C25 4.69448 24.0113 3.71094 22.8027 3.71094ZM22.4653 5.17578C21.7549 5.88853 13.4104 14.2603 13.0676 14.6042C12.7812 14.8914 12.2189 14.8916 11.9324 14.6042L2.53467 5.17578H22.4653ZM1.46484 18.8225V6.17749L7.76685 12.5L1.46484 18.8225ZM2.53467 19.8242L8.80098 13.5375L10.895 15.6383C11.7531 16.4992 13.2473 16.4989 14.1051 15.6383L16.1991 13.5375L22.4653 19.8242H2.53467ZM23.5352 18.8225L17.2332 12.5L23.5352 6.17749V18.8225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9b7e03f4e470ef1fca188f75e6447313.svg";
export { ForwardRef as ReactComponent };